module.exports = __webpack_public_path__ + "assets/9127a4828ef4d5a9611d834cfc1d7d0e.jpg";